// apps/admin/src/i18n/config.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en';
import esTranslations from './locales/es';
import ptTranslations from './locales/pt';

// Only initialize if not already initialized
if (!i18n.isInitialized) {
  i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        en: {
          translation: enTranslations
        },
        es: {
          translation: esTranslations
        },
        pt: {
          translation: ptTranslations
        }
      },
      fallbackLng: 'en',
      debug: import.meta.env.MODE === 'development' && import.meta.env.VITEST !== 'true',
      interpolation: {
        escapeValue: false
      }
    });
}

export default i18n;
